var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWorried = function SvgWorried(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "#E81212",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M7.22275 13.0995H6.57275C6.12402 13.0995 5.76025 12.7357 5.76025 12.287V6.70996C5.76025 6.26123 6.12402 5.89746 6.57275 5.89746H7.22275C7.67149 5.89746 8.03525 6.26123 8.03525 6.70996V12.287C8.03525 12.7357 7.67149 13.0995 7.22275 13.0995Z",
    stroke: "#E81212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8.03516 11.8401V7.52301C8.03516 7.09203 8.20636 6.67871 8.51111 6.37396C8.81585 6.06922 9.22918 5.89801 9.66016 5.89801H13.383C13.6801 5.89799 13.9689 5.99566 14.205 6.17595C14.4411 6.35625 14.6113 6.60918 14.6895 6.89576L15.7501 10.7893C15.8048 10.9901 15.8125 11.2009 15.7725 11.4052C15.7325 11.6095 15.646 11.8018 15.5196 11.9673C15.3932 12.1327 15.2304 12.2667 15.0438 12.359C14.8572 12.4513 14.6518 12.4993 14.4436 12.4993H12.2255V14.5625C12.2255 14.8498 12.1114 15.1254 11.9082 15.3285C11.705 15.5317 11.4295 15.6458 11.1422 15.6458H11.1227C10.9433 15.6458 10.7668 15.6013 10.6089 15.5162C10.451 15.4311 10.3167 15.3081 10.2181 15.1583L8.03516 11.8401Z",
    stroke: "#E81212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgWorried;